var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMeet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_1302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1537 19.9666L31.8325 25.3746L38.1245 29.44L39.219 20.0008L38.1245 10.7744L31.7119 14.3458L27.1537 19.9666Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00341797 28.5611V36.6047C0.00341797 38.4413 1.47771 39.9325 3.29434 39.9325H11.2489L12.896 33.8549L11.2489 28.5611L5.79149 26.8955L0.00341797 28.5611Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2489 0L0.00341797 11.3714L5.79187 13.033L11.2489 11.3714L12.866 6.14957L11.2489 0Z",
    fill: "#E94235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00354004 28.5646H11.2488V11.3711H0.00354004V28.5646Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3081 4.81519L38.1243 10.7746V29.44L45.3377 35.4226C46.4176 36.2779 47.9972 35.4984 47.9972 34.1104V6.10088C47.9972 4.69747 46.3799 3.92173 45.3079 4.81538",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1537 19.9658V28.5607H11.2488V39.9321H34.8338C36.6504 39.9321 38.1245 38.4409 38.1245 36.6043V29.4392L27.1537 19.9658Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8338 0H11.2488V11.3714H27.1537V19.9663L38.1247 10.7738V3.32796C38.1247 1.491 36.6504 0.000189573 34.8338 0.000189573",
    fill: "#FFBA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_1302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMeet);
export default __webpack_public_path__ + "static/media/ic_meet.207ed365db9be6c12fd3d1edb2c5a3d4.svg";
export { ForwardRef as ReactComponent };